/**
 * layout/header.ts
 *
 * Central navigation + branding configuration.
 * Consumed by:
 * - DesktopNav
 * - MobileNav
 * - Header
 * - ProfileNav
 * - Gallery (unused)
 */

import type { ReactNode } from "react";
import Logo from "public/logo.svg";

/** Navigation item used across desktop + mobile nav components. */
export interface NavItem {
  href: string;
  title: string;
  alt: string;
  /** Whether this item should appear in desktop nav */
  desktop: boolean;
}

/** Header configuration structure. */
export interface HeaderConfig {
  logo: {
    href: string;
    title: ReactNode;
    alt: string;
  };
  nav: NavItem[];
  profileNav: NavItem[];
}

export const HEADER: HeaderConfig = {
  logo: {
    href: "/",
    title: <Logo />,
    alt: "Logo",
  },

  nav: [
    {
      href: "/",
      title: "Home",
      alt: "my home on the web",
      desktop: true,
    },
    {
      href: "/#about",
      title: "About",
      alt: "know more about me",
      desktop: true,
    },
    {
      href: "/#venture",
      title: "Venture",
      alt: "showcase of my work",
      desktop: true,
    },
    {
      href: "/catalogue",
      title: "Catalogue",
      alt: "a list of all my reads",
      desktop: true,
    },
    {
      href: "/resume",
      title: "Résumé",
      alt: "my professional résumé",
      desktop: true,
    },
  ],

  /** Additional actions/settings items (currently unused). */
  /*
{
  href: "/gallery",
  title: "Gallery",
  alt: "Images and stuff",
  desktop: true,
},*/

  profileNav: [],
};
